import { AccountMovementsViewModel } from "../../accounting/models/accounting-movement.model";

export class PrestamosModel {

  uid: string;
  accountingModelsCortoPlazoNumber: string;
  accountingModelsLargoPlazoNumber: string;
  numero: string;
  entidad: string;
  filesPrestamosUid: string;
  importeInicial: number;
  comisionApertura: number;
  importePendiente: number;
  fechaConstitucion: Date;
  plazo: number;
  fechaFinalizacion: Date;
  tipoInteres: number;
  carencia: number;
  tipoLiquidaciones: number;
  bankAccountsUid: string;
  duracion: number;
  manualMovement: AccountMovementsViewModel;

  projectUid?: string;
  expenseProjectTypeUid?: string;

  constructor() { }

  // Enums - No eliminar
  /* Mensual = 1,
  Bimensual = 2,
  Trimestral = 3,
  Semestral = 4,
  Anual = 5 */

}

export class ConstitucionPrestamosModel {

  uid: string;
  prestamosId: string;
  fecha: Date;
  concepto: string;
  importe: number;
  comisionApertura: number;
  gastosBancarios: number;
  bankAccountsUid: string;
  bankAccountInfo: string;

  activitiesUid: string;
  activitiesName: string;
   projectUid?: string;
  expenseProjectTypeUid?: string;

  constructor() {
    this.comisionApertura = 0;
    this.gastosBancarios = 0;
  }

  // Enums - No eliminar
  /* Corto_Plazo = 1,
  Largo_Plazo = 2, */

}

export class DeudaACortoPlazoPrestamosModel {

  uid: string;
  prestamosId: string;
  fecha: Date;
  concepto: string;
  importe: number;

  activitiesUid: string;
  activitiesName: string;

   projectUid?: string;
  expenseProjectTypeUid?: string;

  constructor() { }

}

export class PagoCuotasPrestamosModel {

  uid: string;
  prestamosId: string;
  fecha: Date;
  concepto: string;
  importeCapital: number;
  intereses: number;
  gastosBancarios: number;
  bankAccountsUid: string;
  bankAccountInfo: string;

  activitiesUid: string;
  activitiesName: string;

   projectUid?: string;
  expenseProjectTypeUid?: string;

  constructor() {
    this.intereses = 0;
    this.gastosBancarios = 0;
  }

}

